if (!customElements.get('product-modal')) {
	customElements.define(
		'product-modal',
		class ProductModal extends ModalDialog {
			constructor() {
				super()

				this.setupCarousel()
			}

			hide() {
				super.hide()
			}

			show(opener) {
				super.show(opener)
				this.showActiveMedia()
			}

			showActiveMedia() {
				this.querySelectorAll(
					`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
				).forEach((element) => {
					element.classList.remove('active')
				})
				const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`)
				const activeMediaTemplate = activeMedia.querySelector('template')
				const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null
				// Fix 01.09.2026: aktives Lightbox-Bild sofort laden (lazy -> eager), sonst bleibt der mobile Bild-Zoom weiss
				const activeImage = activeMedia.nodeName == 'IMG' ? activeMedia : activeMedia.querySelector('img')
				if (activeImage && activeImage.loading == 'lazy') activeImage.loading = 'eager'
				activeMedia.classList.add('active')
				activeMedia.scrollIntoView()

				const container = this.querySelector('[role="document"]')
				container.scrollLeft = (activeMedia.width - container.clientWidth) / 2

				if (
					activeMedia.nodeName == 'DEFERRED-MEDIA' &&
					activeMediaContent &&
					activeMediaContent.querySelector('.js-youtube')
				)
					activeMedia.loadContent()
			}

			setupCarousel() {
				const carousel = this.querySelector('[data-media-carousel]')
				if (!carousel || !window.Flickity) return

				new Flickity(carousel, {
					cellAlign: 'left',
					contain: true,
					freeScroll: true,
					pageDots: false,
				})
			}
		}
	)
}

